import UserRepo from './UserRepo';
import ProfileRepo from './ProfileRepo';
import BankRepo from './BankRepo';
import AuthRepo from './AuthRepo';

const repositories = {
    auth: AuthRepo,
    user: UserRepo,
    profile: ProfileRepo,
    bank: BankRepo,
}

export const RepositoryFactory = {
    get: name => repositories[name],
};